/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Status_Loading_CommitInputs */



/**
* | output |
* | --- |
* | "Loading commit..." |
*
* @param {Team_Project_Import_Status_Loading_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_status_loading_commit = /** @type {((inputs?: Team_Project_Import_Status_Loading_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Status_Loading_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du commit...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Commit wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento commit in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка коммита...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando confirmación...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载提交...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कमिट लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando commit...")
	return /** @type {LocalizedString} */ ("Loading commit...")
});